export enum DmsFilesGridColName {
  Select = 'select',
  Name = 'name',
  OriginalName = 'originalName',
  OriginalPath = 'originalPath',
  Extension = 'extension',
  Tags = 'tags',
  Path = 'path',
  UpdatedOn = 'updatedOn',
  CreatedOn = 'createdOn',
  RecordingTime = 'recordingTime',
  DeletedOn = 'deletedOn',
  RemovedDate = 'removedDate',
  CreatedBy = 'createdBy',
  OwnerId = 'ownerId',
  ContentLanguage = 'contentLanguage',
  Size = 'size',
  Actions = 'actions',
}

export enum DmsTagsGridColName {
  Select = 'select',
  Name = 'name',
  Type = 'type',
}
